import "./VerifyPhoneModal.scss"
import { FC, useState } from "react"
import { Button, Typography } from "@mui/material"
import PinInput from "../../PinInput/PinInput.component"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useAppDispatch } from "../../../redux/hooks"
import {
  getUserAsync,
  sendVerificationCodeAsync,
  verifyCodeAsync,
} from "../../../redux/slices/authSlice"
import { useNavigate } from "react-router-dom"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"
import { ROUTES } from "../../../config/routes.const"
import { useBranding } from "../../../hooks/useBranding"
import { useIsGoTo } from "../../../hooks/useIsGoTo"

type VerifyPhoneModalProps = {
  open: boolean
  phoneNumber: string
  handleClose: () => void
}

const VerifyPhoneModal: FC<VerifyPhoneModalProps> = ({
  open,
  phoneNumber,
  handleClose,
}) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [resendAttempts, setResendAttempts] = useState(0)
  const [canResend, setCanResend] = useState(true)
  const {
    VERIFY_PHONE_MODAL_TITLE,
    VERIFY_PHONE_MODAL_DESCRIPTION,
    VERIFY_PHONE_MODAL_DIDNT_GET_CODE,
    VERIFY_PHONE_MODAL_RESEND,
    BTN_CONTINUE,
  } = useTranslationLabel()
  const { pinSchema } = useValidationSchemas()
  const { logo  } = useBranding()
  const { isGoTo  } = useIsGoTo()
  const { formData, errors, handleChange, validateField, validateForm } =
    useFormValidation(
      {
        pin: "",
      },
      pinSchema,
    )

  const handlePinChange = (newPin: string) => {
    handleChange({ target: { name: "pin", value: newPin } } as any) //TODO LOW fix any
  }

  const handleResendCode = async () => {
    if (!canResend) return

    setLoading(true)
    await dispatch(sendVerificationCodeAsync({ phoneNumber }))

    setResendAttempts((prev) => prev + 1)
    setCanResend(false)

    setTimeout(() => {
      setCanResend(true)
    }, 60000)

    setLoading(false)
  }

  const handlePinComplete = async (pin: string) => {
    setLoading(true)
    if (validateForm()) {
      await dispatch(
        verifyCodeAsync({
          pin,
          phoneNumber,
        }),
      )
        .unwrap()
        .then(async (res) => {
          await dispatch(getUserAsync())
            .unwrap()
            .then(() => {
              navigate(ROUTES.ACCOUNT)
            })
        })
        .catch((err) => {
          alert("Wrong pin code")
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={VERIFY_PHONE_MODAL_TITLE}
      description={VERIFY_PHONE_MODAL_DESCRIPTION}
      description2={phoneNumber}
      image={logo}
      imageStyle={isGoTo?{}:{ height: "140px" }}
      className="verify-number-modal"
      loading={loading}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handlePinComplete(formData.pin)
        }}
        className="pin-form column center"
        dir="ltr"
            >
        <PinInput
          value={formData.pin}
          onPinChange={handlePinChange}
          shouldFocus={true}
        />
        {errors.pin && <div className="error-message">{errors.pin}</div>}

        <Typography variant="caption" className="resend-link" component={"div"}>
          {VERIFY_PHONE_MODAL_DIDNT_GET_CODE}
          <span onClick={handleResendCode}>{VERIFY_PHONE_MODAL_RESEND}</span>
        </Typography>
        <Button type="submit" variant="contained" className="primary-btn">
          {BTN_CONTINUE}
        </Button>
      </form>
    </GenericModal>
  )
}

export default VerifyPhoneModal
